/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  CustomerData,
  CountryCode,
} from '@/models';

import { id } from './id';

const customers: CustomerData[] = [
  {
    id: id(),
    addresses: [
      {
        id: id(),
        country: CountryCode.TWN,
        name: '楊雙雙',
        address1: '新北市五股區工商路18巷16號',
        city: '新北市',
        stateOrRigion: '五股區',
        phone: '+886912345678',
      },
      {
        id: id(),
        country: CountryCode.TWN,
        name: '楊瀚翰',
        address1: '新北市五股區工商路18巷11號',
        city: '新北市',
        stateOrRigion: '五股區',
        phone: '+886911222333',
      },
    ],
  },
];

export default customers;
